import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class OutsideDentsReferenceService extends BaseReferenceService {
  constructor() {
    super('OutsideDentsReference');
  }
}
